import { ECrmCompanyType, ECrmDirectoryEntryType, IDirectoryEntry } from "services/CrmApi/types/DirectoryEntry";
import { isCompanyProfile } from "../helpers";

const validateTravelCompanyForPublishing = (directoryEntry: IDirectoryEntry): string[] => {
  const messages: string[] = [];

  if (!directoryEntry?.country) {
    messages.push('Country is required.');
  }
  if (!directoryEntry?.address) {
    messages.push('Address is required.');
  }
  const contacts = [... (directoryEntry?.linkedDirectoryEntries || []) ].filter( directoryEntry => directoryEntry.type === ECrmDirectoryEntryType.PERSON );
  if (!contacts.filter(item => item.contactType?.code === 'TA')?.length) {
    messages.push('Travel Agent contact is required.');
  }

  return messages;
}

const validateSupplierForPublishing = (directoryEntry: IDirectoryEntry): string[] => {
  const messages: string[] = [];

  if (!directoryEntry?.country) {
    messages.push('Country is required.');
  }
  if (!directoryEntry?.address) {
    messages.push('Address is required.');
  }
  if (!directoryEntry?.currency) {
    messages.push('Currency is required.');
  }

  return messages;
}

const validateHotelForPublishing = (directoryEntry: IDirectoryEntry): string[] => {
  const messages: string[] = [];

  if (!directoryEntry?.country) {
    messages.push('Country is required.');
  }
  if (!directoryEntry?.currency) {
    messages.push('Currency is required.');
  }

  return messages;
}

export const validateCompanyForPublishing = (directoryEntry?: IDirectoryEntry): string[] => {
  if (!directoryEntry) {
    return [];
  }
  const validatorMapping = {
    [ECrmCompanyType.TRAVEL_COMPANY]: validateTravelCompanyForPublishing,
    [ECrmCompanyType.ACTIVITIES]: validateSupplierForPublishing,
    [ECrmCompanyType.GROUND_SERVICES]: validateSupplierForPublishing,
    [ECrmCompanyType.TRANSFERS]: validateSupplierForPublishing,
    [ECrmCompanyType.HOTEL]: validateHotelForPublishing,
  };
  if (!isCompanyProfile(directoryEntry?.profile)) {
    return [];
  }
  const validator = validatorMapping[directoryEntry?.profile.companyType.code]
  if (!validator) {
    return [];
  }
  const validationMessages = validator(directoryEntry);
  return validationMessages;
}